export const LANG_TURKISH = "tr";
export const LANG_ENGLISH = "en";
export const LANG_DEUTSCH = "de";
